import APP_CONFIG from './config';
import PageNotFound from './pages/PageNotFound.vue';
import AccountActivation from './pages/AccountActivation.vue';
import EmailActivation from './pages/EmailActivation.vue';
import ResetPassword from './pages/ResetPassword.vue';

const ROUTES = [
    {
        path: 'aktywacja-konta/:token',
        component: AccountActivation,
        meta: {
            title: `${APP_CONFIG.MAIN_PAGE_TITLE} - Aktywacja konta`,
        },
    },
    {
        path: 'aktywacja-email/:token',
        component: EmailActivation,
        meta: {
            title: `${APP_CONFIG.MAIN_PAGE_TITLE} - Aktywacja email`,
        },
    },
    {
        path: 'reset-hasla/:token',
        component: ResetPassword,
        meta: {
            title: `${APP_CONFIG.MAIN_PAGE_TITLE} - Reset hasła`,
        },
    },
    {
        path: '',
        alias: '*',
        component: PageNotFound,
        meta: {
            title: `${APP_CONFIG.MAIN_PAGE_TITLE} - 404`,
        },
    },
];

export default ROUTES;
